module.exports = __webpack_public_path__ + "logo-grupo.png?6452dea3a06d75b1a49f523272207043";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo-grupo.png
// module id = 316
// module chunks = 0